import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "legend", "errorFieldNames", "errorText"];
import React, { useEffect, useRef, useState } from 'react';
import { css } from 'styled-components';
import { useFormikContext } from 'formik';
import { VisuallyHidden } from '@figure/frontlib-accessibility';
import { IS_DEV } from '../../../constants';
import { StyledFieldset, Div } from '../../Styled';
import { accessPropertyByDotNotationString, randomString } from '../../../utils';
import { cssByBreakpoint, flex } from '../../../styling';
import { COLORS, TYPOGRAPHY } from '../../../themes';
import { HelperText } from '../../text';
import { useTheme } from '../../../contexts';
export var questionnaireContainer = cssByBreakpoint([css(["width:100%;", " > .legend,> label{", " color:", ";margin:0 0 16px 0;}"], flex('flex-start', 'flex-start', 'column'), TYPOGRAPHY.M, COLORS.NEUTRAL_600), css(["flex-direction:row;justify-content:space-between;> .legend,> label{margin:0 56px 0 0;}> *{&:nth-child(2){flex:0 0 auto;}}"])]);

var QuestionnaireFieldset = function QuestionnaireFieldset(_ref) {
  var children = _ref.children,
      legend = _ref.legend,
      errorFieldNames = _ref.errorFieldNames,
      _ref$errorText = _ref.errorText,
      externalErrorText = _ref$errorText === void 0 ? '' : _ref$errorText,
      rest = _objectWithoutProperties(_ref, _excluded);

  if (IS_DEV && !legend) console.error("Fieldsets require legend text.");

  var _useTheme = useTheme(),
      mediaQueryMatches = _useTheme.mediaQueryMatches;

  var id = useRef(randomString(10)).current;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      errorText = _useState2[0],
      setErrorText = _useState2[1];

  var _useFormikContext = useFormikContext(),
      errors = _useFormikContext.errors;

  useEffect(function () {
    setErrorText(errorFieldNames ? errorFieldNames.reduce(function (err, name) {
      var error = accessPropertyByDotNotationString(errors, name);
      if (error) return error;
      return err;
    }, '') : '');
  }, [errors, errorFieldNames]);
  var isMobile = !mediaQueryMatches.MD;
  return /*#__PURE__*/React.createElement(StyledFieldset, _extends({
    "aria-labelledby": id
  }, rest), /*#__PURE__*/React.createElement(Div, {
    className: "fieldset",
    $css: questionnaireContainer
  }, /*#__PURE__*/React.createElement(Div, {
    className: "legend",
    id: id
  }, legend, (errorText || externalErrorText) && /*#__PURE__*/React.createElement(VisuallyHidden, null, " ", errorText || externalErrorText), (errorText || externalErrorText) && !isMobile && /*#__PURE__*/React.createElement(HelperText, {
    "aria-hidden": true,
    error: true,
    $css: css(["margin-top:8px;"])
  }, errorText || externalErrorText)), children), (errorText || externalErrorText) && isMobile && /*#__PURE__*/React.createElement(HelperText, {
    "aria-hidden": true,
    error: true,
    $css: css(["margin-top:16px;"])
  }, errorText || externalErrorText));
};

export default QuestionnaireFieldset;